<div class="title-container">
    <h2 class="title"> {{ 'Reports.TreatedCases.Title' | translate }} </h2>
    <hr class="separation-line" />
  </div>
  <section class="filters-container">
    <div class="fieldrow">
      <fieldset class="customers">
        <label class="label"> {{'Reports.Filters.CustomerNumbers' | translate}} </label>
        <custom-multi-select [options]="customers$ | async" [clearEnabled]="true" [searchEnabled]="true"
          [(selectedKeys)]="selectedCustomers" [displayDetailedSelection]="true"
          [disabled]="userAssignedCustomersCount <= 1" (selectedKeysChange)="onSelectedCustomersChange($event)">
        </custom-multi-select>
      </fieldset>
      <fieldset>
        <label class="label"> {{'Reports.Filters.StartDate' | translate}} </label>
        <p-datepicker [(ngModel)]="startDate" [dateFormat]="dateFormat"></p-datepicker>
      </fieldset>
      <fieldset>
        <label class="label"> {{'Reports.Filters.EndDate' | translate}} </label>
        <p-datepicker [(ngModel)]="endDate" [dateFormat]="dateFormat"></p-datepicker>
      </fieldset>
  
      <fieldset>
        <div class="buttons">
          <button class="button-basic" [disabled]="isLoading"
            (click)="onGenerateReport()">{{'Reports.Buttons.GenerateReport' |
            translate}}</button>
          <button class="button-basic-reverse" [disabled]="isLoading"
            (click)="onExportExcelClick()">{{'Reports.Buttons.Download' |
            translate}}</button>
        </div>
      </fieldset>
    </div>
    <label class="totals-label" *ngIf="this.totalCases">{{this.totalCases}}</label>
  </section>
  <section class="results-container" *ngIf="treatedCases">
    <p-table #treatedCasesTable size="small" [paginator]="false" [columns]="cols" [lazy]="true"      
      [totalRecords]="totalNumberOfItems" selectionMode="single" [loading]="isLoading" [value]="treatedCases">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th [pSortableColumn]="col.name" *ngFor="let col of columns"> {{ col.translationTag | translate }}
            <p-sortIcon [field]="col.name"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-case let-columns="columns">
        <tr>
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.type">
              <ng-container *ngSwitchCase="'date'"> {{ case[col.name] | date: dateFormat }} </ng-container>
              <ng-container *ngSwitchCase="'decimal'"> {{ case[col.name] | number : numberFormat.style: numberFormat.culture }} </ng-container>
              <ng-container *ngSwitchDefault>{{case[col.name]}}</ng-container>
            </ng-container>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </section>